import { useStyles } from "../context";
import { CoreFlightsComponent, CORE_FLIGHTS_NAME } from "@b2bportal/core-types";

export const useFlightStyles = (
  componentName: keyof typeof CoreFlightsComponent,
  defaultStyles?: object
) => {
  return useStyles(CORE_FLIGHTS_NAME, componentName, defaultStyles);
};
